import { HomeHeading, HomeLink } from './presentation'
import styles from './home.module.css'

export function ImageGallery() {
  return (
    <div className={styles.galleryShell}>
      <div
        className={styles.gallery}
        role="region"
        aria-label="Form design examples"
        tabIndex={0}
      >
        <div className={styles.galleryTrack}>
          {[0, 1].map(copy => (
            <div
              key={copy}
              className={styles.galleryGroup}
              aria-hidden={copy === 1 ? true : undefined}
            >
              {Array.from({ length: 10 }, (_, index) => (
                <img
                  key={index}
                  src={`/static/examples/form-showcase-${index + 1}.webp`}
                  alt={
                    copy === 0 ? `HeyForm form design example ${index + 1}` : ''
                  }
                  width={1183}
                  height={806}
                  loading="lazy"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ImageGallery

export function BrandedForms() {
  return (
    <section className={styles.section} aria-labelledby="home-brand-title">
      <div className={styles.container}>
        <div className={styles.split}>
          <div>
            <HomeHeading
              id="home-brand-title"
              title="Forms that actually feel like your brand"
            >
              Customize fonts, colors, layouts, and flow. Give every question
              the look and feel of your business.
            </HomeHeading>
            <HomeLink href="https://my.heyform.net/sign-up">
              Design your form
            </HomeLink>
          </div>
          <div className={styles.media}>
            <img
              src="/static/customization.webp"
              alt="HeyForm design controls alongside a customized customer satisfaction form"
              width={2000}
              height={1600}
              loading="lazy"
            />
          </div>
        </div>
        <ImageGallery />
      </div>
    </section>
  )
}
